/* ============================================================
   Llorrea header — hamburgermenu, ook op desktop
   Delegatie, dus werkt ook na herladen in de theme editor.
   ============================================================ */
(function(){
  if(window.lloHeaderBound) return;
  window.lloHeaderBound = true;

  function panelOf(btn){
    var root = btn.closest('[data-llo-header]');
    return root ? root.querySelector('[data-llo-panel]') : null;
  }

  function setOpen(root, open){
    if(!root) return;
    var panel = root.querySelector('[data-llo-panel]');
    var btn = root.querySelector('[data-llo-toggle]');
    if(open){
      root.classList.add('is-open');
      if(panel) panel.hidden = false;
      if(btn) btn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    } else {
      root.classList.remove('is-open');
      if(btn) btn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if(panel){
        window.setTimeout(function(){
          if(!root.classList.contains('is-open')) panel.hidden = true;
        }, 260);
      }
    }
  }

  document.addEventListener('click', function(e){
    var t = e.target;

    var toggle = t.closest ? t.closest('[data-llo-toggle]') : null;
    if(toggle){
      e.preventDefault();
      var root = toggle.closest('[data-llo-header]');
      setOpen(root, !root.classList.contains('is-open'));
      return;
    }

    var close = t.closest ? t.closest('[data-llo-close]') : null;
    if(close){
      e.preventDefault();
      setOpen(close.closest('[data-llo-header]'), false);
      return;
    }

    /* submenu open en dicht klappen */
    var sub = t.closest ? t.closest('[data-llo-sub]') : null;
    if(sub){
      e.preventDefault();
      var li = sub.closest('[data-llo-item]');
      if(li) li.classList.toggle('is-open');
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var open = document.querySelector('[data-llo-header].is-open');
    if(open) setOpen(open, false);
  });

  document.addEventListener('shopify:section:load', function(){
    var open = document.querySelector('[data-llo-header].is-open');
    if(open) setOpen(open, false);
  });
})();
